import { KibsiClient } from './base';
const SERVICE = 'tenant';
export class DashboardKibsiClient extends KibsiClient {
    constructor(params) {
        super(params, SERVICE);
    }
    list(paginationRequest, requestConfig) {
        const { continuationToken, pageSize, sort, criteria } = paginationRequest || {};
        const { dashboardIds, siteId } = criteria ?? {};
        return this.get('/dashboards', {
            ...requestConfig,
            ...{ params: { continuationToken, pageSize, sort, dashboardIds: dashboardIds?.join(','), siteId } },
        });
    }
    read(entityId, requestConfig) {
        return this.get(`/dashboards/${entityId}`, requestConfig);
    }
    create(entity, requestConfig) {
        return this.post('/dashboards', entity, requestConfig);
    }
    update(entity, requestConfig) {
        return this.put(`/dashboards/${entity.dashboardId}`, entity, requestConfig);
    }
    delete(id, requestConfig) {
        return this.del(`/dashboards/${id}`, requestConfig);
    }
    getDashboardUrl(entityId, requestConfig) {
        return this.get(`/dashboards/${entityId}/url`, requestConfig);
    }
}
//# sourceMappingURL=dashboard.js.map